import { encryptStatus } from "@core-shop/services";
import { useCloud } from "./useCloud";

export function useCloudAuthState() {
  const { data: cloudData, isLoading } = useCloud();
  const state = encryptStatus(cloudData?.ShopCloud?.state ?? "");
  return { isLoading, ...state };
}
